import React from 'react';
import { useAbility } from '@casl/react';
import { AbilityContext } from '../context/casl/AbilityContext';

interface PermissionCheck {
  I: string; // action
  a: string; // subject
}

interface CanAnyProps {
  of: PermissionCheck[];
  children: React.ReactNode;
}

/**
 * A declarative component that renders its children if the current user
 * has AT LEAST ONE of the permissions in the provided array.
 *
 * Example:
 * <CanAny of={[{ I: 'read', a: 'all_details' }, { I: 'read', a: 'own_details' }]}>
 *   <Button>View Details</Button>
 * </CanAny>
 */
export const CanAny: React.FC<CanAnyProps> = ({ of: permissions, children }) => {
  const ability = useAbility(AbilityContext);

  // Use the .some() method to check if any permission in the array passes the ability check.
  const hasAtLeastOnePermission = permissions.some(permission =>
    ability.can(permission.I, permission.a)
  );

  if (hasAtLeastOnePermission) {
    return <>{children}</>;
  }

  return null;
};
